module.exports = __webpack_public_path__ + "img/dianchi-60.985753e5.svg";